import React from 'react'

export default function Experience() {
  return (
    <div className="experience-content d-flex justify-content-between align-items-center" id="expreince">
        <div className="experience-box d-flex align-items-center">
            <h4>4+</h4>
            <span>Years Experience</span>
        </div>
        <div className="experience-box d-flex align-items-center">
            <h4>10+</h4>
            <span>Completed Projects</span>
        </div>
        <div className="experience-box d-flex align-items-center">
            <h4>5</h4>
            <span>Happy Clients</span>
        </div>
        <div className="experience-box d-flex align-items-center">
            <h4>2+</h4>
            <span>Happy Clients</span>
        </div>
    </div>
  )
}
